import { LAYERURL} from './LayerUrlTypes'
const initialState = {
    layerUrl: null
}

const addLayerUrl = (state = initialState, action) => {


    switch (action.type) {
        case LAYERURL:
            
            return {
                layerUrl: action.load
            }
    
        default:
          return state
    }

}


export default addLayerUrl;